var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@impargo/components/Button';
import Flex from '@impargo/components/Flex';
import Text from '@impargo/components/Text';
import { Offstage } from '@impargo/reusable-components/dist/Components/Offstage';
import * as Sentry from '@sentry/react';
import { Component } from 'react';
import { Trans, Translation } from 'react-i18next';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, isWebGLError: false };
    }
    componentDidCatch(error, errorInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            Sentry.withScope((scope) => __awaiter(this, void 0, void 0, function* () {
                Object.keys(errorInfo).forEach(key => {
                    scope.setExtra(key, errorInfo[key]);
                });
                scope.setTag('crashed', 'true');
                Sentry.captureException(error);
            }));
        });
    }
    static getDerivedStateFromError(error) {
        const isWebGLError = error.message.includes('WebGL');
        return { error, isWebGLError };
    }
    render() {
        if (this.state.error) {
            return (_jsx(Translation, { children: (t) => (_jsxs(Flex, Object.assign({ "data-testid": 'error-boundary-container', direction: 'column', justify: 'center', alignItems: 'center', gap: 'spacingX2', width: '100%' }, { children: [_jsx(Text, Object.assign({ textAlign: 'center', variant: 'heading1' }, { children: t('errors.oops') })), _jsx(Text, Object.assign({ textAlign: 'center' }, { children: this.state.isWebGLError ? t('errors.webgl') : t('errors.error') })), _jsx(Offstage, Object.assign({ showIf: this.state.isWebGLError }, { children: _jsx(Text, Object.assign({ textAlign: 'center', whiteSpace: 'pre-wrap' }, { children: _jsx(Trans, { i18nKey: 'errors.webgl_help', components: { a: _jsx("a", { href: 'https://get.webgl.org/', target: '_blank' }) } }) })) })), _jsx(Button, Object.assign({ shape: 'default', onClick: () => Sentry.showReportDialog(), "data-testid": 'error-boundary-report-dialog-button' }, { children: t('errors.report') })), _jsx(Offstage, Object.assign({ showIf: !this.state.isWebGLError }, { children: _jsx(Button, Object.assign({ shape: 'flat', onClick: () => window.location.reload(), "data-testid": 'error-boundary-reload-button' }, { children: t('errors.reload') })) }))] }))) }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
